import { Link } from "react-router-dom";

const stats = [
  { num: "1200+", label: "全网深度稿件", icon: "ri-article-line" },
  { num: "380万+", label: "月度阅读量", icon: "ri-eye-line" },
  { num: "56%", label: "深度读者占比", icon: "ri-user-heart-line" },
  { num: "7年", label: "独立深耕媒体", icon: "ri-compass-3-line" },
];

const principles = [
  { icon: "ri-focus-3-line", title: "信源求证", desc: "事实性信息以公开可查证材料为基础，多方交叉核实后再下笔。" },
  { icon: "ri-eye-off-line", title: "敬畏边界", desc: "尊重事实与法律边界，不预设立场，不做无依据的臆测与情绪审判。" },
  { icon: "ri-team-line", title: "尊重个体", desc: "聚焦事件与行业现象，把被折叠成标题的人，还原成完整、具体的个体。" },
];

const quotes = [
  { text: "和其他只会搬料的号不一样，今日瓜报真的会把来龙去脉讲清楚，看完再回头吃瓜，感觉完全不一样。", who: "读者 · 木木", role: "关注 3 年" },
  { text: "最喜欢深度报道专栏，信息量扎实，角度客观，是我唯一会设置提醒追更的娱乐号。", who: "读者 · 阿诺", role: "编辑部忠实读者" },
  { text: "重点瓜分析把复杂的娱乐圈关系讲得明明白白，标题标题都不浮夸，看完很受益。", who: "读者 · 小满", role: "内容从业者" },
];

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-24 bg-secondary-50/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          {/* 品牌介绍 */}
          <div>
            <p className="section-kicker text-xs font-semibold text-accent-700">关于今日瓜报</p>
            <h2 className="mt-2 font-serif text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
              我们为什么做一家“深度吃瓜”媒体
            </h2>
            <p className="mt-5 text-[15px] leading-8 text-foreground-700">
              娱乐信息爆炸的今天，“吃瓜”已经成为无数人日常的一部分。但越来越多的人在看完一段热搜后，只记住了情绪，却没看清门道——谁在发声、证据何在、背后是怎样一套运转逻辑。
            </p>
            <p className="mt-4 text-[15px] leading-8 text-foreground-700">
              今日瓜报由此而来。我们不追逐一时的标题流量，而是用头条解读帮你快速抓住重点，用重点瓜分析与深度报道把事件的来龙去脉讲透，用每月封面故事为重要的人与事留下完整注脚。我们相信，认真看待娱乐，也是理解这个时代的一种方式。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {principles.map((p) => (
                <div key={p.title} className="rounded-xl bg-background-50 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                    <i className={p.icon} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-3 font-serif text-base font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>

            {/* 数据条 */}
            <div className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-xl border border-background-200 bg-background-50 p-4 text-center">
                  <i className={`${s.icon} text-xl text-primary-600`} aria-hidden="true"></i>
                  <p className="mt-2 font-serif text-xl font-black text-foreground-950">{s.num}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 读者口碑 */}
          <div className="lg:pl-6">
            <h2 className="flex items-center gap-2 font-serif text-xl font-black text-foreground-950">
              <i className="ri-heart-3-fill text-primary-500" aria-hidden="true"></i>
              读者怎么说
            </h2>
            <div className="mt-5 space-y-4">
              {quotes.map((q, i) => (
                <figure key={i} className="relative rounded-xl bg-background-50 p-5 md:p-6">
                  <i className="ri-double-quotes-l absolute -top-2 right-5 text-4xl text-secondary-200" aria-hidden="true"></i>
                  <blockquote className="text-[15px] leading-7 text-foreground-800">{q.text}</blockquote>
                  <figcaption className="mt-3 flex items-center gap-3">
                    <span className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold text-background-50 ${i === 0 ? "bg-primary-500" : i === 1 ? "bg-accent-500" : "bg-secondary-600"}`}>
                      {q.who.replace("读者 · ", "").slice(0, 1)}
                    </span>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{q.who}</p>
                      <p className="text-xs text-foreground-500">{q.role}</p>
                    </div>
                    <span className="ml-auto flex gap-0.5 text-accent-500" aria-label="5星好评">
                      {Array.from({ length: 5 }).map((_, x) => (
                        <i key={x} className="ri-star-fill text-xs" aria-hidden="true"></i>
                      ))}
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>

            <div className="mt-6 flex items-center justify-between rounded-xl bg-foreground-950 px-5 py-4 text-background-50">
              <div>
                <p className="font-serif text-base font-bold">想成为我们的作者或提供线索？</p>
                <p className="mt-0.5 text-xs text-background-100/70">欢迎通过底部订阅与联系通道，一起把内容做深做透。</p>
              </div>
              <Link to="/#contact" className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm hover:bg-accent-600 transition-colors">
                联系编辑部 <i className="ri-mail-line" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}